<template>
  <v-row
    align="stretch"
    justify="start"
  >
    <v-col
      cols="12"
    >
      <base-material-card
        color="coolrunner"
        icon="mdi-account-arrow-right"
        :avatar="item.picture || null "

        inline
        class="px-5 py-3"
      >
        <template
          v-slot:after-heading
        >
          <v-col>
            <div class="text-h2 font-weight-light">
              {{ $t('basic_information') }}
            </div>

            <v-btn
              v-if="$route.params.id && $route.params.id != 'null'"
              color="green"
              bottom
              right
              class="ml-auto"
              target="cooldesk"
              :href="`https://partner.homerunner.com/customers/${$route.params.id}/login`"
            >
              {{ $t('go_to_cooldesk') }}
            </v-btn>
          </v-col>
        </template>
        <v-form>
          <v-container class="py-0">
            <v-row>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model="item.name"
                  :label="$t('name')"
                />
              </v-col>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model="item.company_name"
                  :label="$t('company')"
                />
              </v-col>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model="item.email"
                  :label="$t('email')"
                />
              </v-col>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model="item.phone"
                  :label="$t('phone')"
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-select
                  v-model="item.payment_method"
                  :label="$t('payment_method')"
                  dense
                  :items="[
                    { text: $t('invoice'), value: 'invoice' },
                    { text: $t('creditcard'), value: 'creditcard' },
                  ]"
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-select
                  v-model="item.level"
                  :label="$t('level')"
                  dense
                  :items="[
                    { text: $t('business_solution'), value: 'vip' },
                    { text: $t('basic'), value: 'basic' },
                  ]"
                />
              </v-col>
              <v-col
                v-if="item.business"
                cols="4"
              >
                <v-text-field
                  v-model="item.erp_number"
                  :label="$t('erp_number')"
                  readonly
                />
              </v-col>
              <v-col
                v-if="item.business"
                cols="4"
              >
                <v-text-field
                  v-model="item.company_vat"
                  :label="$t('vat')"
                />
              </v-col>
              <v-col
                v-if="item.business && item.hubspot"
                cols="4"
              >
                <v-text-field
                  v-model="item.hubspot.bsm"
                  disabled
                  :label="$t('bsm')"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <v-row>
                  <v-col
                    cols="2"
                  >
                    <v-switch
                      v-model="item.verified_phone"
                      dense
                      :label="`${$t('phone')} ${$t('verified').toLowerCase()}`"
                    />
                  </v-col>
                  <v-col
                    cols="2"
                  >
                    <v-switch
                      v-model="item.verified_email"
                      dense
                      :label="`${$t('email')} ${$t('verified').toLowerCase()}`"
                    />
                  </v-col>
                  <v-col
                    cols="2"
                  >
                    <v-switch
                      v-model="item.business"
                      dense
                      :disabled="init_business"
                      :label="`${$t('business_customer')}`"
                    />
                  </v-col>
                  <v-col
                    cols="2"
                  >
                    <v-switch
                      v-model="item.test_mode"
                      dense
                      :label="`${$t('test_mode')}`"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="6"
              >
                <p>{{ $t('support_note') }}</p>
                <v-textarea
                  v-model="item.support_note"
                  solo
                  name="input-7-4"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <v-row v-if="this.$route.params.id && this.$route.params.id != 'null'">
          <v-col cols="6">
            <base-material-card
              color="coolrunner"
              icon="mdi-account"
              inline
              class="px-5 py-3"
            >
              <template
                v-slot:after-heading
              >
                <div class="text-h2 font-weight-light">
                  {{ $t('billing_address') }}
                </div>
              </template>
              <v-form>
                <v-container class="py-0">
                  <v-row>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="item.billing_address.name"
                        :label="$t('name')"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="item.billing_address.company_name"
                        :label="$t('company')"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="item.billing_address.street1"

                        :label="$t('addressline', {number: 1})"
                      />
                    </v-col>
                    <v-col
                      cols="4"
                    >
                      <v-text-field
                        v-model="item.billing_address.zip_code"

                        :label="$t('zip_code')"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="item.billing_address.city"

                        :label="$t('city')"
                      />
                    </v-col>
                    <v-col
                      cols="2"
                      class="mt-4"
                    >
                      <base-paginated-select
                        :selected="item.billing_address.country"
                        endpoint="countries"
                        :label="$t('country')"
                        item-text="full_name"
                        selected-item-text="full_name"
                        @value-change="v => item.billing_address.country = v"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="item.billing_address.email"

                        :label="$t('email')"
                        type="email"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="item.billing_address.phone"

                        :label="$t('phone')"
                        type="tel"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </base-material-card>
          </v-col>
          <v-col cols="6">
            <base-material-card
              color="coolrunner"
              icon="mdi-account"
              inline
              class="px-5 py-3"
            >
              <template
                v-slot:after-heading
              >
                <div class="text-h2 font-weight-light">
                  {{ $t('shipping_address') }}
                </div>
              </template>
              <v-form>
                <v-container class="py-0">
                  <v-row>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="item.shipping_address.name"
                        :label="$t('name')"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="item.shipping_address.company_name"
                        :label="$t('company')"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="item.shipping_address.street1"

                        :label="$t('addressline', {number: 1})"
                      />
                    </v-col>
                    <v-col
                      cols="4"
                    >
                      <v-text-field
                        v-model="item.shipping_address.zip_code"

                        :label="$t('zip_code')"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="item.shipping_address.city"

                        :label="$t('city')"
                      />
                    </v-col>
                    <v-col
                      cols="2"
                      class="mt-4"
                    >
                      <base-paginated-select
                        :selected="item.shipping_address.country"
                        endpoint="countries"
                        :label="$t('country')"
                        item-text="full_name"
                        selected-item-text="full_name"
                        @value-change="v => item.shipping_address.country = v"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="item.shipping_address.email"

                        :label="$t('email')"
                        type="email"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="item.shipping_address.phone"

                        :label="$t('phone')"
                        type="tel"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </base-material-card>
          </v-col>
        </v-row>
        <v-col>
          <v-row>
            <v-btn
              v-if="$route.params.id && $route.params.id != 'null'"
              color="blue"
              bottom
              right
              class="ml-auto"
              target="podio"
              :href="`https://external.coolrunner.dk/boarding/customer/${$route.params.id}`"
            >
              {{ $t('go_to_podio') }}
            </v-btn>
            <v-btn
              color="green"
              bottom
              right
              class="ml-auto"

              @click="saveCustomer()"
            >
              <v-icon class="mr-3">
                mdi-content-save
              </v-icon>
              {{ $t('save') }}
            </v-btn>
          </v-row>
        </v-col>
      </base-material-card>
    </v-col>
  </v-row>
</template>
<script>
  import _ from 'lodash'
  import localstorage from '../../../../plugins/localstorage'

  export default {
    props: {
      loading: {
        type: Boolean,
        default: false,
      },
      item: {
        type: Object,
        default: () => ({
          name: '',
          support_note: '',
          billing_address: {
            name: '',
            company_name: '',
            street1: '',
            country: { id: 194, full_name: 'Denmark', iso: 'DK', iso3: 'DNK', numeric: '208', region: 'The North', zip_format: '^\\d{4}$', address_format: '{street_name} {street_number}, {zip_code} {city}, {state}, {country_name}', phone_prefix: '45', phone_format: '.+', active: true, created_at: '2018-07-19 12:20:04', updated_at: '2019-11-11 09:47:13', deleted_at: null },
            zip_code: '',
            city: '',
            email: '',
            phone: '',
          },
          shipping_address: {
            name: '',
            company_name: '',
            street1: '',
            country: { id: 194, full_name: 'Denmark', iso: 'DK', iso3: 'DNK', numeric: '208', region: 'The North', zip_format: '^\\d{4}$', address_format: '{street_name} {street_number}, {zip_code} {city}, {state}, {country_name}', phone_prefix: '45', phone_format: '.+', active: true, created_at: '2018-07-19 12:20:04', updated_at: '2019-11-11 09:47:13', deleted_at: null },
            zip_code: '',
            city: '',
            email: '',
            phone: '',
          },
          price_groups: [],
        }),
      },
    },
    data: () => ({
      init_business: false,
    }),
    computed: {
      localStorage: () => localstorage,
    },
    mounted: function () {
      this.init_business = this.item.business
    },
    methods: {
      saveCustomer: function () {
        this.$emit('save-customer')
      },
    },
  }
</script>
